import React, { useEffect, useCallback } from 'react';
import Header from './Header';
import Footer from './Footer';
import './Contacto.css';

const Contacto = () => {
  const backgroundImageUrl = `${process.env.PUBLIC_URL || ''}/images/CONTACTO_fondo.svg`;
  const backgroundStyle = {
    backgroundImage: `url("${backgroundImageUrl}")`,
  };

  useEffect(() => {
    // Load jQuery for Zoho form
    if (!window.jQuery) {
      const script = document.createElement('script');
      script.src = 'https://ajax.googleapis.com/ajax/libs/jquery/3.6.4/jquery.min.js';
      script.async = true;
      document.body.appendChild(script);
    }

    // Load Zoho analytics script
    const analyticsScript = document.createElement('script');
    analyticsScript.id = 'wf_anal';
    analyticsScript.src = 'https://crm.zohopublic.com/crm/WebFormAnalyticsServeServlet?rid=e692426c819aaf07c6130c73ce7483599ffec992ad7956ccf892317174941ddfb3cdab5691699bbbdd64943e515680a6gidac2e130ed104acb4a075f95f6eadd48a35388ae5b73f3b36c0e2e1c05c570788gid4021d7a61a9507b3daa4b43272edb4e6d73d1ef77eb66c3a0b88262044d8db60gide2ae257e87cca91741e47bdf285e1d97987b2db657f7f252edad200db0a2cefa&tw=5fa3c28bb4345d395c78dbb200cf8ad68fb6e95bab19282fb0fc8e90ad0f9e46';
    document.body.appendChild(analyticsScript);

    return () => {
      // Cleanup if needed
    };
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Use the checkMandatory function directly
    const isMandatory = checkMandatory();
    if (!isMandatory) {
      // Re-enable submit button if validation fails
      const submitBtn = document.querySelector('.crmWebToEntityForm .formsubmit');
      if (submitBtn) {
        submitBtn.removeAttribute('disabled');
      }
      return;
    }

    if (typeof window.jQuery === 'undefined') {
      alert('Error: jQuery no está cargado. Por favor, recarga la página.');
      return;
    }

    const formData = new FormData(e.target);
    
    window.jQuery.ajax({
      url: 'https://crm.zoho.com/crm/WebToLeadForm',
      type: 'POST',
      data: formData,
      cache: false,
      contentType: false,
      processData: false,
      success: function(data) {
        const splashinfodom = document.getElementById('wf_splash_info');
        if (splashinfodom) {
          splashinfodom.innerText = data.actionvalue;
        }
        const splashdom = document.getElementById('wf_splash');
        if (splashdom) {
          e.target.reset();
          splashdom.style.display = '';
          setTimeout(function() {
            splashdom.style.display = 'none';
          }, 5000);
        }
        const submitBtn = document.querySelector('.crmWebToEntityForm .formsubmit');
        if (submitBtn) {
          submitBtn.removeAttribute('disabled');
        }
      },
      error: function(data) {
        alert('Ocurrió un error al enviar el formulario');
        const submitBtn = document.querySelector('.crmWebToEntityForm .formsubmit');
        if (submitBtn) {
          submitBtn.removeAttribute('disabled');
        }
      }
    });
  };

  const addAriaChecked = useCallback((e) => {
    const checkboxElem = e.target;
    if (checkboxElem !== undefined && checkboxElem.checked) {
      checkboxElem.setAttribute('aria-checked', 'true');
    } else if (checkboxElem !== undefined && !checkboxElem.checked) {
      checkboxElem.setAttribute('aria-checked', 'false');
    }
  }, []);

  const validateEmail = useCallback(() => {
    const form = document.forms['WebToLeads6708423000001823236'];
    if (!form) return true;
    const emailFld = form.querySelectorAll('[ftype=email]');
    let i;
    for (i = 0; i < emailFld.length; i++) {
      const emailVal = emailFld[i].value;
      if ((emailVal.replace(/^\s+|\s+$/g, '')).length !== 0) {
        const atpos = emailVal.indexOf('@');
        const dotpos = emailVal.lastIndexOf('.');
        if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= emailVal.length) {
          alert('Introduzca una dirección de correo electrónico válida.');
          emailFld[i].focus();
          return false;
        }
      }
    }
    return true;
  }, []);

  const checkMandatory = useCallback(() => {
    const mndFileds = ['Company', 'Last Name'];
    const fldLangVal = ['Empresa', 'Apellidos'];
    const form = document.forms['WebToLeads6708423000001823236'];
    if (!form) return true;

    for (let i = 0; i < mndFileds.length; i++) {
      const fieldObj = form[mndFileds[i]];
      if (fieldObj) {
        if (((fieldObj.value).replace(/^\s+|\s+$/g, '')).length === 0) {
          if (fieldObj.type === 'file') {
            alert('Seleccione un archivo para cargar.');
            fieldObj.focus();
            return false;
          }
          alert(fldLangVal[i] + ' no puede estar vacío.');
          fieldObj.focus();
          return false;
        } else if (fieldObj.nodeName === 'SELECT') {
          if (fieldObj.options[fieldObj.selectedIndex].value === '-None-') {
            alert(fldLangVal[i] + ' no puede ser nulo.');
            fieldObj.focus();
            return false;
          }
        } else if (fieldObj.type === 'checkbox') {
          if (fieldObj.checked === false) {
            alert('Por favor acepte ' + fldLangVal[i]);
            fieldObj.focus();
            return false;
          }
        }
      }
    }
    if (!validateEmail()) {
      return false;
    }
    const urlparams = new URLSearchParams(window.location.search);
    if (urlparams.has('service') && (urlparams.get('service') === 'smarturl')) {
      const webform = document.getElementById('webform6708423000001823236');
      const service = urlparams.get('service');
      const smarturlfield = document.createElement('input');
      smarturlfield.setAttribute('type', 'hidden');
      smarturlfield.setAttribute('value', service);
      smarturlfield.setAttribute('name', 'service');
      webform.appendChild(smarturlfield);
    }
    const submitBtn = document.querySelector('.crmWebToEntityForm .formsubmit');
    if (submitBtn) {
      submitBtn.setAttribute('disabled', true);
    }
    return true;
  }, [validateEmail]);

  // Make functions globally available
  useEffect(() => {
    window.addAriaChecked6708423000001823236 = addAriaChecked;
    window.validateEmail6708423000001823236 = validateEmail;
    window.checkMandatory6708423000001823236 = checkMandatory;
    
    return () => {
      delete window.addAriaChecked6708423000001823236;
      delete window.validateEmail6708423000001823236;
      delete window.checkMandatory6708423000001823236;
    };
  }, [addAriaChecked, validateEmail, checkMandatory]);

  return (
    <div className="contacto-page">
      <div className="contacto-background" style={backgroundStyle}></div>
      <Header />
      <div className="page-content">
        <section className="contacto-info-section contacto-info-section-top" aria-label="Información de contacto">
          <h2 className="contacto-info-title">INFORMACIÓN DE CONTACTO</h2>
          <div className="contacto-info-grid">
            <div className="contacto-info-block">
              <h3 className="contacto-info-heading">CONTACTO DIRECTO</h3>
              <p className="contacto-info-item">
                <span className="contacto-info-label">Tel:</span>{' '}
                <a href="tel:+5073721960" className="contacto-info-link">(507) 372-1960</a>
              </p>
              <p className="contacto-info-item">
                <span className="contacto-info-label">Cel:</span>{' '}
                <a href="tel:+50768228836" className="contacto-info-link">(507) 6822-8836</a>
              </p>
              <p className="contacto-info-item">
                <span className="contacto-info-label">Email:</span>{' '}
                <a href="mailto:info@solectric.com.pa" className="contacto-info-link">info@solectric.com.pa</a>
              </p>
            </div>
            <div className="contacto-info-block">
              <h3 className="contacto-info-heading">OFICINA CORPORATIVA</h3>
              <a href="https://maps.app.goo.gl/u9mfhtb2QeGE9L6UA" target="_blank" rel="noopener noreferrer" className="contacto-info-link contacto-info-address-link">
                <p className="contacto-info-address">
                  Torre Bicsa Piso 30<br />
                  Oficina 3008<br />
                  Ciudad Panamá
                </p>
              </a>
            </div>
            <div className="contacto-info-block">
              <h3 className="contacto-info-heading">SUCURSAL DE VENTAS</h3>
              <a href="https://maps.app.goo.gl/cCAygZjJgCq523eg6" target="_blank" rel="noopener noreferrer" className="contacto-info-link contacto-info-address-link">
                <p className="contacto-info-address">
                  Cárdenas, Plaza Cárdenas<br />
                  Center, local A-1<br />
                  Ciudad de Panamá, Ancon
                </p>
              </a>
            </div>
            <div className="contacto-info-block">
              <h3 className="contacto-info-heading">HORARIO DE ATENCIÓN</h3>
              <p className="contacto-info-item">L–V: 08:00–19:00</p>
              <p className="contacto-info-item">S: 08:00–12:00</p>
            </div>
          </div>
        </section>

        <h1>CONECTA CON SOLETRIC</h1>
        
        <div className="contacto-header">
          <p className="contacto-subtitle">¿TIENES UN PROYECTO EN MARCHA?</p>
          <p className="contacto-subtitle-second">HABLEMOS SOBRE SOLUCIONES ELÉCTRICAS INTEGRALES.</p>
          <p className="contacto-description">
            En SOLETRIC desarrollamos soluciones en energía, agua, cableado y tecnología verde. Cuéntanos qué necesitas y nuestro equipo te contactará.
          </p>
        </div>

        <div className="contacto-form-section">
          <h2 className="contacto-form-title">SOLICITAR ASESORÍA TÉCNICA</h2>
          
          <div id="crmWebToEntityForm" className="zcwf_lblLeft crmWebToEntityForm">
            <div className="wf_customMessageBox" id="wf_splash" style={{ display: 'none' }}>
              <div className="wf_customCircle">
                <div className="wf_customCheckMark"></div>
              </div>
              <span id="wf_splash_info"></span>
            </div>

            <form 
              id="webform6708423000001823236" 
              name="WebToLeads6708423000001823236" 
              acceptCharset="UTF-8"
              onSubmit={handleSubmit}
            >
              <input type="text" style={{ display: 'none' }} name="xnQsjsdp" value="e111e2f613701149283cde8c2f0f766376316b1f58b4ecf505ed27d8beedc7fe" readOnly />
              <input type="hidden" name="zc_gad" id="zc_gad" value="" />
              <input type="text" style={{ display: 'none' }} name="xmIwtLD" value="1e8a8b00e2b09f6fb851f65fbce8a920057e8f30917a85d5009bd6304e04e7ea7c7efffc1822853e6cfcdafab8c4296a" readOnly />
              <input type="text" style={{ display: 'none' }} name="actionType" value="TGVhZHM=" readOnly />
              <input type="text" style={{ display: 'none' }} name="returnURL" value="null" readOnly />

              <div className="form-group">
                <label htmlFor="First_Name" className="form-label">Nombre</label>
                <input
                  type="text"
                  id="First_Name"
                  name="First Name"
                  className="form-input"
                  ariaRequired="false"
                  ariaLabel="First Name"
                  maxLength="40"
                />
              </div>

              <div className="form-group">
                <label htmlFor="Last_Name" className="form-label">
                  Apellidos <span style={{ color: 'red' }}>*</span>
                </label>
                <input
                  type="text"
                  id="Last_Name"
                  name="Last Name"
                  className="form-input"
                  ariaRequired="true"
                  ariaLabel="Last Name"
                  maxLength="80"
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="Email" className="form-label">Correo electrónico</label>
                <input
                  type="text"
                  id="Email"
                  name="Email"
                  className="form-input"
                  fType="email"
                  autoComplete="false"
                  ariaRequired="false"
                  ariaLabel="Email"
                  maxLength="100"
                />
              </div>

              <div className="form-group">
                <label htmlFor="Phone" className="form-label">Teléfono</label>
                <input
                  type="tel"
                  id="Phone"
                  name="Phone"
                  className="form-input"
                  ariaRequired="false"
                  ariaLabel="Phone"
                  maxLength="30"
                />
              </div>

              <div className="form-group">
                <label htmlFor="Company" className="form-label">
                  Empresa <span style={{ color: 'red' }}>*</span>
                </label>
                <input
                  type="text"
                  id="Company"
                  name="Company"
                  className="form-input"
                  ariaRequired="true"
                  ariaLabel="Company"
                  maxLength="200"
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">Servicios de interés:</label>
                <div className="services-checkboxes">
                  <div className="checkbox-group">
                    <input type="checkbox" id="LEADCF102" name="LEADCF102" className="form-checkbox" onClick={addAriaChecked} />
                    <label htmlFor="LEADCF102">Iluminación</label>
                  </div>
                  <div className="checkbox-group">
                    <input type="checkbox" id="LEADCF106" name="LEADCF106" className="form-checkbox" onClick={addAriaChecked} />
                    <label htmlFor="LEADCF106">Ducto Barras</label>
                  </div>
                  <div className="checkbox-group">
                    <input type="checkbox" id="LEADCF108" name="LEADCF108" className="form-checkbox" onClick={addAriaChecked} />
                    <label htmlFor="LEADCF108">Tableros y Breakes Eléctricos</label>
                  </div>
                  <div className="checkbox-group">
                    <input type="checkbox" id="LEADCF131" name="LEADCF131" className="form-checkbox" onClick={addAriaChecked} />
                    <label htmlFor="LEADCF131">Paneles solares</label>
                  </div>
                  <div className="checkbox-group">
                    <input type="checkbox" id="LEADCF135" name="LEADCF135" className="form-checkbox" onClick={addAriaChecked} />
                    <label htmlFor="LEADCF135">Sistema de Alimentación Ininterrumpida</label>
                  </div>
                  <div className="checkbox-group">
                    <input type="checkbox" id="LEADCF138" name="LEADCF138" className="form-checkbox" onClick={addAriaChecked} />
                    <label htmlFor="LEADCF138">Celda de Media y Baja tensión</label>
                  </div>
                  <div className="checkbox-group">
                    <input type="checkbox" id="LEADCF109" name="LEADCF109" className="form-checkbox" onClick={addAriaChecked} />
                    <label htmlFor="LEADCF109">Pararrayos & Sistema de tierras</label>
                  </div>
                  <div className="checkbox-group">
                    <input type="checkbox" id="LEADCF110" name="LEADCF110" className="form-checkbox" onClick={addAriaChecked} />
                    <label htmlFor="LEADCF110">Transformadores secos Baja y Media tensión</label>
                  </div>
                  <div className="checkbox-group">
                    <input type="checkbox" id="LEADCF104" name="LEADCF104" className="form-checkbox" onClick={addAriaChecked} />
                    <label htmlFor="LEADCF104">Transformadores Tipo Pedestal</label>
                  </div>
                  <div className="checkbox-group">
                    <input type="checkbox" id="LEADCF105" name="LEADCF105" className="form-checkbox" onClick={addAriaChecked} />
                    <label htmlFor="LEADCF105">Control eléctrico</label>
                  </div>
                  <div className="checkbox-group">
                    <input type="checkbox" id="LEADCF101" name="LEADCF101" className="form-checkbox" onClick={addAriaChecked} />
                    <label htmlFor="LEADCF101">Bandejas Metálicas & PVC</label>
                  </div>
                  <div className="checkbox-group">
                    <input type="checkbox" id="LEADCF134" name="LEADCF134" className="form-checkbox" onClick={addAriaChecked} />
                    <label htmlFor="LEADCF134">Bancos de Batería litio</label>
                  </div>
                  <div className="checkbox-group">
                    <input type="checkbox" id="LEADCF132" name="LEADCF132" className="form-checkbox" onClick={addAriaChecked} />
                    <label htmlFor="LEADCF132">Rectificadores Eléctricos</label>
                  </div>
                  <div className="checkbox-group">
                    <input type="checkbox" id="LEADCF137" name="LEADCF137" className="form-checkbox" onClick={addAriaChecked} />
                    <label htmlFor="LEADCF137">Equipos de aire acondicionado de precisión</label>
                  </div>
                  <div className="checkbox-group">
                    <input type="checkbox" id="LEADCF103" name="LEADCF103" className="form-checkbox" onClick={addAriaChecked} />
                    <label htmlFor="LEADCF103">Diseños eléctricos</label>
                  </div>
                  <div className="checkbox-group">
                    <input type="checkbox" id="LEADCF107" name="LEADCF107" className="form-checkbox" onClick={addAriaChecked} />
                    <label htmlFor="LEADCF107">Diseño ducto barras</label>
                  </div>
                  <div className="checkbox-group">
                    <input type="checkbox" id="LEADCF133" name="LEADCF133" className="form-checkbox" onClick={addAriaChecked} />
                    <label htmlFor="LEADCF133">Estudios eléctricos</label>
                  </div>
                  <div className="checkbox-group">
                    <input type="checkbox" id="LEADCF136" name="LEADCF136" className="form-checkbox" onClick={addAriaChecked} />
                    <label htmlFor="LEADCF136">Automatización</label>
                  </div>
                  <div className="checkbox-group">
                    <input type="checkbox" id="LEADCF139" name="LEADCF139" className="form-checkbox" onClick={addAriaChecked} />
                    <label htmlFor="LEADCF139">Diseño de sistemas de aire acondicionado</label>
                  </div>
                </div>
              </div>

              <input type="hidden" style={{ display: 'none' }} name="aG9uZXlwb3Q" value="" readOnly />

              <p className="form-required-note">Los campos con * son obligatorios.</p>

              <button type="submit" id="formsubmit" className="enviar-button formsubmit zcwf_button">
                Enviar proyecto
              </button>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Contacto;
